import styled from '@emotion/styled';

export const ModalBackground = styled.section`
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  z-index: 99;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
`;

export const Modal = styled.article`
  align-items: center;
  width: 312px;
  height: 254px;
  background-color: white;
  border-radius: 4px;
  position: fixed;
  top: 50%;
  left: 50%;
  z-index: 100;
  transform: translate(-50%, -50%);
  padding: 16px;
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #f1f1f1;
  font-size: 16px;
  font-weight: bold;
  color: #696969;
  padding-bottom: 10px;
`;

export const ModalTitleText = styled.span``;
export const ModalBody = styled.div`
  display: flex;
  margin: 32px 0 32px 0;
  justify-content: space-evenly;
`;
export const Kakao = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #696969;
  cursor: pointer;
  span {
    margin-top: 8px;
    font-size: 14px;
    font-weight: 500;
  }
`;
export const Facebook = styled(Kakao)``;
export const Twitter = styled(Kakao)``;

export const ModalClose = styled.div`
  border: none;
  background-color: transparent;
  cursor: pointer;
`;

export const Link = styled.div`
  width: 268px;
  height: 41px;
  display: flex;
  align-items: center;
  border-radius: 4px;
  border: solid 1px #e4e4e4;
  background-color: #f1f1f1;
  padding-left: 12px;
`;

export const Url = styled.div`
  width: 268px;
  overflow: hidden;
  overflow-x: scroll;
  scroll-snap-type: x mandatory;
  font-size: 14px;
  font-weight: normal;
  color: #8b8b8b;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const ShareButton = styled.button`
  position: relative;
  width: 73px;
  height: 42px;
  border: solid 1px #e4e4e4;
  background-color: #fff;
  border-radius: 0 4px 4px 0;
  font-family: Pretendard;
  font-size: 14px;
  font-weight: 500;
  color: #1d1e1f;
  cursor: pointer;
`;
